/**
 * Places `.accordion--below-gallery` blocks by viewport:
 * - Desktop: under the product media gallery slot
 * - Mobile: after the shipment note at the end of the product details column
 */
(function () {
  const PRODUCT_INFO_SELECTOR = '.product-information';
  const ACCORDION_SELECTOR = '.accordion--below-gallery';
  const SLOT_SELECTOR = '.product-information__media-accordion-slot';
  const DETAILS_SELECTOR = '.product-details';
  const DETAILS_CONTENT_SELECTOR = '.product-details > .group-block > .group-block-content';
  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  let isMoving = false;
  let relocateRaf = 0;

  /**
   * @param {HTMLElement} accordion
   * @param {Element} target
   * @param {'append' | 'after'} mode
   */
  function moveAccordion(accordion, target, mode) {
    if (mode === 'append') {
      if (accordion.parentElement === target && accordion === target.lastElementChild) return;
      target.appendChild(accordion);
      return;
    }

    if (accordion.previousElementSibling === target) return;
    target.insertAdjacentElement('afterend', accordion);
  }

  /**
   * Prefer inserting after the shipment note group; fall back to end of details.
   * @param {HTMLElement} productInfo
   * @returns {{ target: Element, mode: 'append' | 'after' } | null}
   */
  function getMobilePlacement(productInfo) {
    const detailsContent =
      productInfo.querySelector(DETAILS_CONTENT_SELECTOR) || productInfo.querySelector(DETAILS_SELECTOR);

    if (!(detailsContent instanceof Element)) return null;

    const shippingChild = Array.from(detailsContent.children).find((child) => {
      if (!(child instanceof HTMLElement)) return false;
      if (child.matches(ACCORDION_SELECTOR) || child.classList.contains('accordion')) return false;
      const text = (child.textContent || '').toLowerCase();
      return text.includes('orders ship') || text.includes('business days');
    });

    if (shippingChild instanceof Element) {
      return { target: shippingChild, mode: 'after' };
    }

    return { target: detailsContent, mode: 'append' };
  }

  function relocateBelowGalleryAccordions() {
    if (isMoving) return;
    isMoving = true;

    try {
      const isMobile = MOBILE_MQ.matches;

      document.querySelectorAll(PRODUCT_INFO_SELECTOR).forEach((productInfo) => {
        if (!(productInfo instanceof HTMLElement)) return;

        const accordions = Array.from(productInfo.querySelectorAll(ACCORDION_SELECTOR)).filter(
          (el) => el instanceof HTMLElement
        );

        accordions.forEach((accordion) => {
          if (isMobile) {
            const placement = getMobilePlacement(productInfo);
            if (placement) {
              moveAccordion(accordion, placement.target, placement.mode);
            }
            return;
          }

          const slot = productInfo.querySelector(SLOT_SELECTOR);
          if (slot instanceof Element) {
            moveAccordion(accordion, slot, 'append');
          }
        });
      });
    } finally {
      isMoving = false;
    }
  }

  function scheduleRelocate() {
    if (relocateRaf) return;
    relocateRaf = window.requestAnimationFrame(() => {
      relocateRaf = 0;
      relocateBelowGalleryAccordions();
    });
  }

  relocateBelowGalleryAccordions();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRelocate);
  }

  const state = /** @type {any} */ (window);
  if (!state.__productAccordionLayoutListeners) {
    state.__productAccordionLayoutListeners = true;

    document.addEventListener('shopify:section:load', scheduleRelocate);
    document.addEventListener('shopify:section:reorder', scheduleRelocate);
    document.addEventListener('shopify:block:select', scheduleRelocate);
    document.addEventListener('shopify:block:deselect', scheduleRelocate);

    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', scheduleRelocate);
    } else if (typeof MOBILE_MQ.addListener === 'function') {
      MOBILE_MQ.addListener(scheduleRelocate);
    }

    // Retry while LPO mounts the customizer / replaces the gallery.
    [100, 400, 1000, 2500].forEach((ms) => setTimeout(scheduleRelocate, ms));

    const observer = new MutationObserver(() => {
      if (!isMoving) scheduleRelocate();
    });

    const observe = () => {
      if (!document.body) return;
      observer.observe(document.body, { childList: true, subtree: true });
    };

    if (document.body) {
      observe();
    } else {
      document.addEventListener('DOMContentLoaded', observe, { once: true });
    }
  }
})();
